// extracted by mini-css-extract-plugin
export default {"footer":"Krbyn","errorMessage":"c20dP","errorMessage__visible":"GlJkd","submitSection":"DdE3c","agreementLink":"bpaRx","submitButton":"LXh21"};